import { useEffect, useState } from "react";
import AccountCompany from "~/assets/icons/AccountCompany";
import AccountMail from "~/assets/icons/AccountMail";
import AccountName from "~/assets/icons/AccountName";
import AccountPhone from "~/assets/icons/AccountPhone";
import AccountProfession from "~/assets/icons/AccountProfession";
import AccountWeb from "~/assets/icons/AccountWeb";
import BlackCircleLoading from "~/assets/icons/BlackCircleLoading";
import { callSendEmail, emailValidation } from "~/lib/utils";
import { UserForm } from "~/types";
import { Modal } from "../../global/Modal.client";

export default function RequestCustomizationFrom({ }) {

    const CUSTOM_PRIVATE = "Private Client";
    const CUSTOM_PROFESSIONAL = "Professional";
    const CUSTOM_DESIGNER = "Designer";
    const checkListContact = ["Email", "Whatsapp", "Call", "Skype"];

    const [form, setForm] = useState({
        name: '',
        lastname: '',
        customerProfile: CUSTOM_PROFESSIONAL,
        email: '',
        phone: '',
        profession: '',
        companyName: '',
        website: '',
        contact: []
    });

    const [errorsForm, setErrorsForm] = useState<UserForm>({
        name: null,
        lastname: null,
        customerProfile: null,
        email: null,
        phone: null,
        profession: null,
        companyName: null,
        website: null,
        contact: null
    })

    const [loading, setLoading] = useState<boolean>(false);

    const [hasSubmitError, setHasSubmitError] = useState(false);
    const [hasSubmitSuccess, setHasSubmitSuccess] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        checkEmail(event);
        const validate = validateFieldsRequired();
        const emailError = emailValidation(event.currentTarget.email);
        if (emailError) {
            setErrorsForm(old => ({ ...old, email: emailError }))
            setLoading(false);
            return;
        }
        if (validate) await sendMail();
    }

    const onChange = (event) => {
        setForm(old => ({ ...old, [event.target.id]: event.target.value }))
    }

    const emptyErrorsForm = () => {
        setErrorsForm({
            name: null,
            lastname: null,
            customerProfile: null,
            email: null,
            phone: null,
            profession: null,
            companyName: null,
            website: null,
            contact: null
        })
    }

    const emptyInputForm = () => {
        setForm({
            name: '',
            lastname: '',
            customerProfile: form.customerProfile,
            email: '',
            phone: '',
            profession: '',
            companyName: '',
            website: '',
            contact: []
        })
    }

    const setPrivate = () => {
        setForm(old => ({ ...old, customerProfile: CUSTOM_PRIVATE }))
    }

    const setProfessional = () => {
        setForm(old => ({ ...old, customerProfile: CUSTOM_PROFESSIONAL }))
    }

    const setDesigner = () => {
        setForm(old => ({ ...old, customerProfile: CUSTOM_DESIGNER }))
    }

    const sendMail = async () => {
        const response = await callSendEmail(form);
        if (response.error) {
            setLoading(false)
            emptyErrorsForm()
            setHasSubmitError(false)
        } else {
            setLoading(false)
            setHasSubmitSuccess(true)
            emptyInputForm()
        }
    }

    useEffect(() => {
        if (hasSubmitError) {
            setTimeout(() => {
                setHasSubmitError(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);

    useEffect(() => {
        if (hasSubmitSuccess) {
            setTimeout(() => {
                setHasSubmitSuccess(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);

    const validateFieldsRequired = () => {
        if (form.customerProfile === '') {
            setErrorsForm(old => ({ ...old, customerProfile: "This field is required" }))
            return false;
        }
        if (form.name === '') {
            setErrorsForm(old => ({ ...old, name: "This field is required" }))
            return false;
        }
        if (form.lastname === '') {
            setErrorsForm(old => ({ ...old, lastname: "This field is required" }))
            return false;
        }
        if (form.email === '') {
            setErrorsForm(old => ({ ...old, email: "This field is required" }))
            return false;
        }
        if (form.phone === '') {
            setErrorsForm(old => ({ ...old, phone: "This field is required" }))
            return false;
        }
        if (form.customerProfile !== CUSTOM_PRIVATE)
            if (form.profession === '') {
                setErrorsForm(old => ({ ...old, profession: "This field is required" }))
                return false;
            }
        return true;
    }
    const checkEmail = (event: React.FormEvent<HTMLFormElement>) => {
        if (!event.currentTarget.email.validity.valid) {
            setErrorsForm(old => ({ ...old, email: 'Please enter a valid email' }))
        }
    }

    const checkInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const contact = form.contact;
        if (event.target.checked) {
            contact?.push(event.target.value)
            setForm(old => ({ ...old, contact }))
        } else {
            const newContacts = contact?.filter((e) => e !== event.target.value);
            setForm(old => ({ ...old, contact: newContacts ?? [] }))
        }
    };

    const [show, setShow] = useState(false);
    return (
        <>
            {show &&
                <Modal close={() => setShow(false)}>
                    <>
                        <div className="requestCustomizationForm">
                            <div className="requestCustomizationForm__header">
                                <h1>Select your profile:</h1>

                            </div>
                            <div className="requestCustomizationForm__selectButtons">
                                <button className={form.customerProfile == CUSTOM_PROFESSIONAL ? `activeLink text-white text-xl` : ``} onClick={setProfessional}> Professional </button>
                                <button className={form.customerProfile == CUSTOM_DESIGNER ? `activeLink text-white text-xl` : ``} onClick={setDesigner}> Designer </button>
                                <button className={form.customerProfile == CUSTOM_PRIVATE ? `activeLink text-white text-xl` : ``} onClick={setPrivate}> Private Client </button>
                            </div>
                            <form onSubmit={handleSubmit}>

                                <div className="mt-3 containerInput"> <AccountName />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.name ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="name"
                                        name="name"
                                        type="text"
                                        autoComplete="given-name"
                                        required
                                        placeholder="First name"
                                        aria-label="First name"
                                        value={form.name}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.name ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.name} &nbsp;
                                    </p>
                                </div>

                                <div className="mt-3 containerInput"> <AccountName />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.lastname ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="lastname"
                                        name="lastname"
                                        type="text"
                                        autoComplete="family-name"
                                        required
                                        placeholder="Last name"
                                        aria-label="Last name"
                                        value={form.lastname}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.lastname ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.lastname} &nbsp;
                                    </p>
                                </div>

                                <div className="mt-3 containerInput"> <AccountMail />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.email ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        placeholder="Email address"
                                        aria-label="Email address"
                                        value={form.email}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.email ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.email} &nbsp;
                                    </p>
                                </div>

                                <div className="mt-3 containerInput"> <AccountPhone />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.phone ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        autoComplete="tel"
                                        required
                                        placeholder="Phone"
                                        aria-label="Phone"
                                        value={form.phone}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.phone ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.phone} &nbsp;
                                    </p>
                                </div>

                                {form.customerProfile != CUSTOM_PRIVATE ?

                                    <><div className="mt-3 containerInput border"><AccountProfession />
                                        <select id="profession" name="profession" defaultValue={''} className="form-control" required
                                            onChange={onChange} value={form.profession}>
                                            <option value="" disabled selected>Profession...</option>
                                            <option value="Hotel">Hotel</option>
                                            <option value="Restaurant">Restaurant</option>
                                            <option value="Café - Bar">Cafe - Bar</option>
                                            <option value="Hospital">Hospital</option>
                                        </select>
                                    </div>
                                        {!errorsForm.profession ? ('') : (<p className={`text-red-500 text-xs`}>{errorsForm.profession} &nbsp;</p>)}

                                        <div className="mt-3 containerInput"><AccountCompany />
                                            <input
                                                className={`userLogin__input emailInput ${errorsForm.companyName ? ' border-red-500' : 'border-gray-500'
                                                    }`}
                                                id="companyName"
                                                name="companyName"
                                                type="text"
                                                required
                                                placeholder="Company name"
                                                aria-label="Company name"
                                                value={form.companyName}
                                                onChange={onChange}
                                            />
                                            <p
                                                className={`text-red-500 text-xs ${!errorsForm.companyName ? 'invisible' : ''}`}
                                            >
                                                {errorsForm.companyName} &nbsp;
                                            </p>
                                        </div>

                                        <div className="mt-3 containerInput"><AccountWeb />
                                            <input
                                                className={`userLogin__input emailInput ${errorsForm.website ? ' border-red-500' : 'border-gray-500'
                                                    }`}
                                                id="website"
                                                name="website"
                                                type="text"
                                                required
                                                placeholder="Website"
                                                aria-label="Website"
                                                value={form.website}
                                                onChange={onChange}
                                            />
                                            <p
                                                className={`text-red-500 text-xs ${!errorsForm.website ? 'invisible' : ''}`}
                                            >
                                                {errorsForm.website} &nbsp;
                                            </p>
                                        </div>
                                    </> : ""

                                }

                                <p className="requestCustomizationForm__contact-options">Preferred contact or schedule a meeting:</p>
                                <div className="requestCustomizationForm__select">
                                    {checkListContact.map((item, index) => (
                                        <div className="requestCustomizationForm__footerOption" key={index}>
                                            <input className="form-check-input test" type="checkbox" id={item} value={item} onChange={checkInput} />
                                            <label className="form-check-label" htmlFor={item}>{item}</label>
                                        </div>
                                    ))}</div>
                                <br></br>
                                <button className="black-button submitBtn">
                                    {!loading ? 'Submit' :
                                        <div className="text-center">LOADING  <BlackCircleLoading /></div>
                                    }
                                </button>
                            </form>
                            {hasSubmitError && (
                                <div className="flex items-center justify-center mb-6">
                                    <p className="m-4 text-s text-red-500 errorSend">
                                        Sorry, the request could not be sent. Please try again.
                                    </p>
                                </div>
                            )}
                            {hasSubmitSuccess && (
                                <div className="flex items-center justify-center mb-6">
                                    <p className="m-4 text-s text-green-500 confirmSend">
                                        Your request was sent successfully.
                                    </p>
                                </div>
                            )}
                        </div>
                    </>
                </Modal>}
            <div className="requestPrice">
                <div className="formContainer">
                    <span onClick={() => setShow(true)} className="black-button btn-customization">Request Customization</span>
                </div>
            </div>
        </>
    )
}